import {
    get,
    post,
} from '../utility/Requests';
import type {
    Connection,
    Connector,
    ConnectorTemplate,
} from './Connector.types';

// https://alpha.uipath.com/entity/IntegrationTest/connections_/swagger/index.htm;

export function getConnections(organizationId: string, tenantId: string): Promise<Connection[]> {
    const url = `/${organizationId}/${tenantId}/connections_/api/v1/Connections?allFolders=true&folderDefaults=true`;
    return get<Connection[]>(url, { ignoreBasePath: true });
}

export function createConnection(organizationId: string, tenantId: string, folderKey: string | undefined, connectorKey: string): Promise<{ authUrl: string }> {
    const headers = folderKey ? {
        'X-Uipath-Folderkey': folderKey,
        extendRequestHeaders: 'true',
    } : undefined;
    return post(`/${organizationId}/${tenantId}/connections_/api/v1/Connections/`, {
        ignoreBasePath: true,
        body: { connector: connectorKey },
        headers,
    });
}

export function getConnectors(organizationId: string, tenantId: string): Promise<Connector[]> {
    const url = `/${organizationId}/${tenantId}/connections_/api/v1/Connectors`;
    return get<Connector[]>(url, { ignoreBasePath: true }).then((data) => data.sort((a, b) => a.name.localeCompare(b.name)));
}

export function getConnectorConnections(organizationId: string, tenantId: string, connectorKey: string): Promise<Connection[]> {
    const url = `/${organizationId}/${tenantId}/connections_/api/v1/Connectors/${connectorKey}/connections?allFolders=true&folderDefaults=true`;
    return get<Connection[]>(url, { ignoreBasePath: true });
}

export function getConnectorTemplates(organizationId: string, tenantId: string): Promise<ConnectorTemplate[]> {
    const url = `/${organizationId}/${tenantId}/elements_/v3/element/templates`;
    return get<ConnectorTemplate[]>(url, { ignoreBasePath: true });
}

export function getElements(organizationId: string, tenantId: string, elementInstanceId: string, path: string): Promise<any> {
    const url = `/${organizationId}/${tenantId}/elements_/v3/element/instances/${elementInstanceId}${path}`;
    return get(url, { ignoreBasePath: true });
}
